export default class SelectProjectsService {
  constructor (Api) {
    this.api = Api;
  }

  getSpacesAndProjects () {
    return this.api.get('spaces?limit=-1&include=projects');
  }
}
